module.exports = __webpack_public_path__ + "img/slphouse_main1.5974fa2b.png";